import {useDispatch} from "react-redux";
import {login, logout} from "./redux/actions/authActions";
import {useAuthSelector} from "./redux/reducers/authReducer";
import {useThemeSelector} from "./redux/reducers/themeReducer";
import useWindowSize from "./helpers/useWindowSize";
import breakpoints from "./constants/breakpoints";

export const useController = () => {
    const dispatch = useDispatch();
    const {user, userData} = useAuthSelector();
    const {primaryColor, theme, darkMode} = useThemeSelector();

    const size = useWindowSize();
    const isExtraSmall = size.width < breakpoints.xs;

    const dropdownItems = [{
        key: 'logout', icon: 'LogoutOutlined', value: 'Logout', callback: () => {
            dispatch(logout(() => window.history.pushState({}, document.title, "/")));
        }
    }];

    return {
        login: values => {
            dispatch(login(values))
        },
        refreshThemeSettings: () => {
            window.less
                .modifyVars({
                    "@primary-color": primaryColor
                })
                .then(() => {
                    //do other stuff here
                })
                .catch(error => {
                    console.error(error);
                });
        },
        user,
        userData,
        dropdownItems,
        primaryColor,
        darkMode,
        isExtraSmall,
        theme
    };
};